package com.exura.features.plandefinition.data.remote.dto.plan

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("treatment_plan")
data class TreatmentPlanDto(
    override val title: String,
    override val description: String,
    override val durationInDays: Int? = null,
    override val imageUrl: String? = null
) : BasePlanDto()
